var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3776 4.60938V3.27604C3.3776 2.5688 3.65856 1.89052 4.15865 1.39042C4.65875 0.890327 5.33703 0.609375 6.04427 0.609375C6.75151 0.609375 7.42979 0.890327 7.92989 1.39042C8.42999 1.89052 8.71094 2.5688 8.71094 3.27604V4.60938H10.0443C10.3979 4.60938 10.737 4.74985 10.9871 4.9999C11.2371 5.24995 11.3776 5.58909 11.3776 5.94271V12.6094C11.3776 12.963 11.2371 13.3021 10.9871 13.5522C10.737 13.8022 10.3979 13.9427 10.0443 13.9427H2.04427C1.69065 13.9427 1.35151 13.8022 1.10146 13.5522C0.851413 13.3021 0.710938 12.963 0.710938 12.6094V5.94271C0.710938 5.58909 0.851413 5.24995 1.10146 4.9999C1.35151 4.74985 1.69065 4.60938 2.04427 4.60938H3.3776ZM4.71094 3.27604V4.60938H7.3776V3.27604C7.3776 2.92242 7.23713 2.58328 6.98708 2.33323C6.73703 2.08318 6.39789 1.94271 6.04427 1.94271C5.69065 1.94271 5.35151 2.08318 5.10146 2.33323C4.85141 2.58328 4.71094 2.92242 4.71094 3.27604ZM2.04427 12.6094H10.0443V5.94271H2.04427V12.6094Z",
    fill: "#407DBB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.8499f074f109b69a2957a27bedfde2a6.svg";
export { ForwardRef as ReactComponent };